import Vue from "vue";
import Router from "vue-router";
import LogRocket from "logrocket";
import LogrocketFuzzySanitizer from 'logrocket-fuzzy-search-sanitizer';
import { clearBreadcrumbsMetaMutation } from "@/graphql/breadcrumbsMeta/queries";
import cookie from "../components/libraries/cookie";
import Layout from "./../components/private/components/pages/Layout.vue";
import Error404 from "./../components/private/components/pages/404.vue";
import RouteRedirect from "@/views/pages/IndexRedirect";
import Dashboard from "@/views/pages/Index";
// import Company from "./../components/private/components/pages/company/Company.vue";

Vue.use(Router);

const router = new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			component: Layout,
			children: [
				/* =============================================================================================
				 * Scheduled maintenance
				 * ===============================================================================================*/
				// {
				// 	path: "/*",
				// 	component: () => import(/* webpackChunkName: "login" */ "./../components/public/pages/Maintenance.vue"),
				// 	name: "login",
				// 	meta: {
				// 		public: true,
				// 		redirectIfLoggedIn: true,
				// 		classes: "col-md-12 col-sm-12 col-lg-10 col-xl-10",
				// 		layout: false
				// 	}
				// },
				/* =============================================================================================
				 * Public routes
				 * ===============================================================================================*/
				{
					path: "/login",
					component: () => import(/* webpackChunkName: "login" */ "./../components/public/pages/Login.vue"),
					name: "login",
					meta: {
						public: true,
						redirectIfLoggedIn: true,
						classes: "col-md-12 col-sm-12 col-lg-10 col-xl-10",
						layout: false
					}
				},
				{
					path: "/logout",
					component: () => import(/* webpackChunkName: "login" */ "./../components/public/pages/Logout.vue"),
					name: "logout",
					meta: {
						public: true,
						redirectIfLoggedIn: false,
						classes: "col-md-12 col-sm-12 col-lg-10 col-xl-10",
						layout: false
					}
				},
				{
					path: "/login/force",
					component: () => import(/* webpackChunkName: "login" */ "./../components/public/pages/ForceLogin.vue"),
					name: "loginForce",
					meta: {
						public: true,
						redirectIfLoggedIn: true,
						classes: "col-md-12 col-sm-12 col-lg-6 col-xl-6",
						layout: false
					}
				},
				{
					path: "/login/organisation",
					component: () => import(/* webpackChunkName: "login" */ "./../components/public/pages/Organisation.vue"),
					name: "login.organisation",
					meta: {
						public: true,
						redirectIfLoggedIn: true,
						classes: "col-md-12 col-sm-12 col-lg-9 col-xl-9",
						layout: false
					}
				},
				{
					path: "/login/:school",
					component: () => import(/* webpackChunkName: "login" */ "./../components/public/pages/School.vue"),
					name: "login.school",
					meta: {
						public: true,
						redirectIfLoggedIn: true,
						classes: "col-md-12 col-sm-12 col-lg-10 col-xl-10",
						layout: false
					}
				},
				{
					path: "/login/:school/emoji",
					component: () => import(/* webpackChunkName: "login" */ "./../components/public/pages/Emoji.vue"),
					name: "login.school.emoji",
					meta: {
						public: true,
						redirectIfLoggedIn: true,
						classes: "col-md-12 col-sm-12 col-lg-9 col-xl-9",
						layout: false
					}
				},
				{
					path: "/chrome-os",
					component: () => import(/* webpackChunkName: "login" */ "./../components/public/pages/ChromeOS.vue"),
					name: "chrome-os",
					meta: {
						public: true,
						redirectIfLoggedIn: true,
						classes: "col-md-12 col-sm-12 col-lg-6 col-xl-6",
						layout: false
					}
				},
				{
					path: "/oauth/authorize/",
					component: () => import(/* webpackChunkName: "login" */ "./../components/public/pages/Authorize.vue"),
					name: "authorize",
					meta: {
						public: true,
						redirectIfLoggedIn: false,
						layout: false,
						bodyClass: "--authorize"
					}
				},
				{
					path: "/magic",
					component: () => import(/* webpackChunkName: "login" */ "./../components/public/pages/Scan.vue"),
					name: "scan",
					meta: {
						public: true,
						redirectIfLoggedIn: true,
						layout: false,
						classes: "col-md-10 col-sm-12 col-lg-8",
						bodyClass: "--standard"
					}
				},
				{
					path: "/sign-up/sent-email",
					component: () => import(/* webpackChunkName: "login" */ "./../components/public/pages/SignUp/SentVerification.vue"),
					name: "sign-up.sent-email",
					meta: {
						public: true,
						layout: false,
						classes: "col-lg-7 col-md-8 col-sm-12",
						bodyClass: "--standard",
						type: "email"
					}
				},
				{
					path: "/invited/:key1",
					component: () => import(/* webpackChunkName: "login" */ "./../components/public/pages/Invited.vue"),
					name: "approval",
					meta: {
						public: true,
						layout: false,
						bodyClass: "--standard"
					}
				},
				{
					path: "/enter/:hash",
					component: () => import(/* webpackChunkName: "login" */ "./../components/public/pages/InviteLogin.vue"),
					name: "login.enter",
					meta: {
						public: true,
						redirectIfLoggedIn: true,
						classes: "col-md-12 col-sm-12 col-lg-6 col-xl-6",
						layout: false
					}
				},
				{
					name: "azure_ad_auth.redirect",
					path: "/azure-ad/redirect",
					component: () => import(/* webpackChunkName: "login" */ "./../components/public/pages/AzureAdAuthRedirect.vue"),
					meta: {
						public: true,
						redirectIfLoggedIn: true,
						layout: false
					}
				},
				{
					path: "/register/teacher",
					component: () => import(/* webpackChunkName: "teacher.register" */ "@/views/layout/GuestLayoutLarge"),
					meta: {
						public: true,
						redirectIfLoggedIn: true,
						layout: false,
						classes: "col-md-10 col-sm-12 col-lg-7"
					},
					children: [
						{
							name: "register.teacher.personalDetailsAndSchool",
							path: "/register/teacher",
							component: () => import(/* webpackChunkName: "teacher.register" */ "@/views/pages/register/teacher/PersonalDetailsAndSchool"),
							meta: {
								public: true,
								redirectIfLoggedIn: true,
								layout: false,
								classes: "col-md-10 col-sm-12 col-lg-7"
							}
						},
						{
							name: "register.teacher.createClassroom",
							path: "/register/teacher/createClassroom",
							props: true,
							component: () => import(/* webpackChunkName: "teacher.register" */ "@/views/pages/register/teacher/CreateClassroom"),
							meta: {
								redirectIfLoggedIn: false,
								layout: false,
								classes: "col-md-10 col-sm-12 col-lg-7",
								auth: {
									freeTeacher: true
								}
							}
						}
					]
				},
				{
					path: "/pdf/invoice/:schoolId/:hash",
					component: () => import(/* webpackChunkName: "PDF" */ "@/views/pages/pdf/Invoice.vue"),
					meta: {
						public: true,
						redirectIfLoggedIn: true,
						layout: false
					}
				},
				{
					path: "/pdf/passwords/:schoolId/:hash",
					component: () => import(/* webpackChunkName: "PDF" */ "@/views/pages/pdf/Passwords.vue"),
					meta: {
						public: true,
						redirectIfLoggedIn: true,
						layout: false
					}
				},

				/*
				 * ===============================================================================================
				 * Private routes
				 * ===============================================================================================
				 */
				{
					path: "/school-disabled",
					component: () => import(/* webpackChunkName: "login" */ "./../components/public/pages/SchoolDisabled.vue"),
					name: "school-disabled",
					meta: {
						classes: "col-md-12 col-sm-12 col-lg-10 col-xl-10",
						layout: false,
						auth: {
							admin: true
						}
					}
				},

				{
					name: "thirdparty.scholarpack",
					path: "/thirdparty/scholarpack-rest",
					component: () => import("./../components/private/components/pages/third-party/ScholarPackRest.vue"),
					meta: {
						auth: {
							admin: true
						}
					}
				},
				{
					name: "install",
					path: "install/:slug",
					component: () => import("./../components/private/components/pages/install/Install.vue"),
					meta: {
						validation: user => {
							if (!user.is_free_teacher && !user.School.sso_enabled) {
								return { name: "singleSignOn", params: { installAttempt: true } };
							}

							return true;
						},
						auth: {
							freeTeacher: true,
							teacher: true,
							admin: true
						}
					}
				},
				{
					name: "third-party-tokens",
					path: "third-party-tokens",
					component: () => import("./../components/private/components/pages/third-party-tokens/ThirdPartyTokens.vue"),
					meta: {
						auth: {
							admin: true
						}
					}
				},
				{
					name: "root",
					path: "/",
					component: RouteRedirect,
					meta: {
						auth: {
							teacher: true,
							admin: true,
							organisation: true,
							student: true
						}
					}
				},
				{
					name: "saml-login",
					path: "/saml-login",
					component: () => import("./../components/private/components/pages/SAMLLogin.vue"),
					meta: {
						title: "SAML",
						public: true,
						layout: false,
						auth: {
							teacher: true,
							admin: true,
							student: true
						}
					}
				},
				{
					name: "dashboard",
					path: "/apps",
					component: Dashboard,
					props: true,
					meta: {
						title: "Dashboard",
						auth: {
							teacher: true,
							admin: true,
							student: true
						}
					}
				},
				{
					name: "saved-password",
					path: "/saved-password/:company",
					component: () => import("./../components/private/components/pages/saved-password/SavedPassword.vue"),
					meta: {
						title: "Saved passwords",
						auth: {
							freeStudent: true,
							freeTeacher: true,
							teacher: true,
							admin: true,
							student: true
						}
					}
				},
				{
					name: "organisation",
					path: "/org",
					component: () => import("./../components/private/components/pages/organisation/Schools.vue"),
					meta: {
						title: "Organisation Dashboard",
						auth: {
							organisation: true
						}
					}
				},
				{
					name: "organisation.school",
					path: "/org/school/:schoolId",
					component: () => import("./../components/private/components/pages/organisation/school/School.vue"),
					meta: {
						auth: {
							organisation: true
						}
					}
				},
				{
					name: "organisation.school.admins",
					path: "/org/school/:schoolId/admins",
					component: () => import("./../components/private/components/pages/organisation/school/Admins.vue"),
					meta: {
						auth: {
							organisation: true
						}
					}
				},
				{
					name: "organisation.applications",
					path: "/org/applications",
					component: () => import("./../components/private/components/pages/organisation/application/Applications.vue"),
					meta: {
						auth: {
							organisation: true
						}
					}
				},
				{
					name: "organisation.application",
					path: "/org/applications/:companyId",
					component: () => import("./../components/private/components/pages/organisation/application/Application.vue"),
					meta: {
						auth: {
							organisation: true
						}
					}
				},
				{
					name: "organisation.application.schools",
					path: "/org/applications/:companyId/schools",
					component: () => import("./../components/private/components/pages/organisation/application/Schools.vue"),
					meta: {
						auth: {
							organisation: true
						}
					}
				},
				{
					name: "organisation.activity",
					path: "/org/activity",
					component: () => import("./../components/private/components/pages/organisation/Activity.vue"),
					meta: {
						auth: {
							organisation: true
						}
					}
				},
				{
					name: "organisation.users",
					path: "/org/users",
					component: () => import("./../components/private/components/pages/organisation/Users.vue"),
					meta: {
						title: "Users",
						auth: {
							organisation: true
						}
					}
				},
				{
					name: "account",
					path: "account",
					component: () => import(/* webpackChunkName: "account" */ "./../components/private/components/pages/account/Account.vue"),
					meta: {
						title: "Account",
						auth: {
							freeTeacher: true,
							freeStudent: true,
							teacher: true,
							organisation: true,
							admin: true,
							student: true
						}
					}
				},
				{
					name: "account.progress",
					path: "account/progress",
					component: () => import(/* webpackChunkName: "account" */ "@/views/pages/account/Progress"),
					meta: {
						title: "Account",
						auth: {
							admin: true,
							freeTeacher: true
						}
					}
				},
				{
					name: "account.saved-passwords",
					path: "account/saved-passwords",
					component: () => import("./../components/private/components/pages/account/SavedPasswords.vue"),
					meta: {
						title: "Account",
						auth: {
							freeTeacher: true,
							teacher: true
						}
					}
				},
				{
					name: "booking",
					path: "booking",
					component: () => import(/* webpackChunkName: "booking" */ "./../components/private/components/pages/booking/Booking.vue"),
					meta: {
						auth: {
							admin: true
						}
					}
				},
				{
					name: "booking.success",
					path: "booking/success/:time",
					component: () => import(/* webpackChunkName: "booking" */ "./../components/private/components/pages/booking/Success.vue"),
					meta: {
						auth: {
							admin: true
						}
					}
				},
				{
					name: "classroom.show",
					path: "classroom/:class",
					component: () => import(/* webpackChunkName: "class" */ "./../components/private/components/pages/class/Class.vue"),
					props: true,
					meta: {
						auth: {
							freeTeacher: true,
							freeStudent: true,
							teacher: true,
							admin: true,
							student: true
						}
					}
				},
				{
					name: "classroom.settings",
					path: "classroom/:class/settings",
					component: () => import(/* webpackChunkName: "class" */ "@/views/pages/classroom/Settings"),
					meta: {
						auth: {
							freeTeacher: true,
							teacher: true
						}
					}
				},
				{
					name: "classroom.students",
					path: "classroom/:class/students",
					props: true,
					component: () => import(/* webpackChunkName: "class" */ "@/views/pages/classroom/Students"),
					meta: {
						auth: {
							freeTeacher: true
						}
					}
				},
				{
					name: "integrate",
					path: "/integrate",
					component: () => import(/* webpackChunkName: "integrate" */ "./../components/private/components/pages/integrate/Integrate"),
					meta: {
						auth: {
							admin: true
						}
					}
				},
				{
					path: "/promotions",
					redirect: { name: "dashboard" },
					component: () => import(/* webpackChunkName: "promotions" */ "@/views/layout/AdminManageLayout"),
					meta: {
						auth: {
							admin: true
						}
					},
					children: [
						{
							name: "promotions.chromeExtension",
							path: "/promotions/chromeExtension",
							component: () => import(/* webpackChunkName: "promotions.chromeExtension" */ "@/views/pages/promotions/ChromeExtension"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						{
							name: "promotions.holidayActivities",
							path: "/promotions/holiday-activities",
							component: () => import(/* webpackChunkName: "holidayActivities" */ "@/views/pages/promotions/HolidayActivities"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						{
							name: "promotions.freeSchoolMeals",
							path: "/promotions/free-school-meals",
							component: () => import(/* webpackChunkName: "freeSchoolMeals" */ "@/views/pages/promotions/FreeSchoolMeals"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						{
							name: "promotions.freeSchoolMeals.order",
							path: "/promotions/free-school-meals/:ref",
							component: () => import(/* webpackChunkName: "freeSchoolMeals" */ "@/views/pages/fsm-orders/FSMOrder"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						{
							name: "promotions.freeSchoolMeals.order.status",
							path: "/promotions/free-school-meals/:ref/status",
							component: () => import(/* webpackChunkName: "freeSchoolMeals" */ "@/views/pages/fsm-orders/FSMOrderStatus"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						{
							name: "promotions.testRegister",
							path: "/promotions/test-register",
							component: () => import(/* webpackChunkName: "testRegister" */ "@/views/pages/promotions/TestRegister"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						{
							name: "promotions.dfe",
							path: "/promotions/department-for-education",
							component: () => import(/* webpackChunkName: "departmentForEducation" */ "@/views/pages/promotions/DepartmentForEducation"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						{
							name: "promotions.data-recovery",
							path: "/promotions/data-recovery",
							component: () => import(/* webpackChunkName: "dataRecovery" */ "@/views/pages/promotions/DataRecovery"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
					]
				},
				{
					path: "/single-sign-on",
					component: () => import(/* webpackChunkName: "singleSignOn" */ "@/views/layout/AdminManageLayout"),
					meta: {
						auth: {
							admin: true
						}
					},
					children: [
						{
							name: "singleSignOn",
							path: "/single-sign-on",
							props: true,
							component: () => import(/* webpackChunkName: "singleSignOn" */ "@/views/pages/SingleSignOn"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						{
							name: "singleSignOn.information",
							path: "/single-sign-on/information",
							component: () => import(/* webpackChunkName: "singleSignOn" */ "@/views/pages/singleSignOn/MoreInformation"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						{
							name: "singleSignOn.approve",
							path: "/single-sign-on/approve",
							component: () => import(/* webpackChunkName: "singleSignOn" */ "@/views/pages/singleSignOn/Approve"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						{
							name: "singleSignOn.old.approve",
							path: "/single-sign-on/approve",
							component: () => import(/* webpackChunkName: "singleSignOn" */ "@/views/pages/singleSignOn.old/Approve"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						{
							name: "singleSignOn.old.install",
							path: "/singleSignOn/install",
							component: () => import(/* webpackChunkName: "singleSignOn" */ "@/views/pages/singleSignOn.old/Install"),
							meta: {
								auth: {
									admin: true
								}
							}
						}
						// {
						// 	name: "singleSignOn.old.download",
						// 	path: "/singleSignOn/download",
						// 	component: () => import(/* webpackChunkName: "singleSignOn" */ "@/views/pages/singleSignOn.old/Download"),
						// 	meta: {
						// 		auth: {
						// 			admin: true
						// 		}
						// 	}
						// }
					]
				},
				{
					name: "teacher-billing",
					path: "/teacher-billing",
					component: () => import(/* webpackChunkName: "teacherBilling" */ "@/views/pages/billing/TeacherBilling"),
					meta: {
						auth: {
							freeTeacher: true,
							admin: true
						}
					}
				},
				{
					path: "/settings",
					component: () => import(/* webpackChunkName: "settings" */ "@/views/layout/AdminManageLayout"),
					meta: {
						auth: {
							admin: true
						}
					},
					children: [
						{
							name: "settings",
							path: "/settings",
							component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/Settings"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						{
							name: "settings.directory",
							path: "/settings/directory",
							component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/settings/Directory"),
							meta: {
								auth: {
									teacher: true,
									admin: true
								}
							}
						},
						{
							name: "settings.directory.show",
							path: "/settings/directory/:person",
							component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/settings/directory/User"),
							meta: {
								auth: {
									teacher: true,
									admin: true
								}
							}
						},
						{
							name: "settings.billing",
							path: "/settings/billing",
							component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/settings/Billing"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						{
							name: "settings.billing.invoices",
							path: "/settings/billing/invoices",
							component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/settings/billing/Invoices"),
							meta: {
								auth: {
									teacher: true,
									admin: true,
									student: true
								}
							}
						},
						{
							name: "settings.admins",
							path: "/settings/admins",
							component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/settings/Admins"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						{
							name: "settings.newTile",
							path: "/settings/new-tile",
							component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/settings/tile/New"),
							meta: {
								auth: {
									freeTeacher: true,
									teacher: true,
									admin: true
								}
							}
						},
						{
							name: "settings.classroom.newTile",
							path: "/settings/:class/new-tile",
							component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/settings/tile/New"),
							meta: {
								auth: {
									freeTeacher: true,
									teacher: true
								}
							}
						},
						{
							name: "settings.tile",
							path: "/settings/tile/:tileId",
							component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/settings/tile/Edit"),
							meta: {
								auth: {
									freeTeacher: true,
									teacher: true,
									admin: true
								}
							}
						},
						{
							name: "settings.classroom.tile",
							path: "/settings/:class/tile/:tileId",
							component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/settings/tile/Edit"),
							meta: {
								auth: {
									freeTeacher: true,
									teacher: true
								}
							}
						},
						{
							path: "/settings/company",
							redirect: { name: "settings.dashboard" },
							component: () => import(/* webpackChunkName: "settings" */ "@/views/layout/AdminManageCompanyLayout"),
							meta: {
								auth: {
									admin: true
								}
							},
							children: [
								{
									name: "settings.company",
									path: "/settings/company/:company",
									component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/settings/company/Overview"),
									meta: {
										auth: {
											admin: true,
											freeTeacher: true
										}
									}
								},
								{
									name: "settings.company.groups",
									path: "/settings/company/:company/groups",
									component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/settings/company/edit/Groups"),
									meta: {
										auth: {
											admin: true
										}
									}
								},
								{
									name: "settings.company.rules",
									path: "/settings/company/:company/rules",
									component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/settings/company/edit/DisplayRules"),
									meta: {
										auth: {
											admin: true
										}
									}
								},
								{
									name: "settings.company.saved-password",
									path: "/settings/company/:company/saved-password",
									component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/settings/company/edit/SavedPasswordSettings"),
									meta: {
										auth: {
											admin: true
										}
									}
								},
								{
									name: "settings.company.permissions",
									path: "/settings/company/:company/permissions",
									component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/settings/company/edit/Permissions"),
									meta: {
										auth: {
											admin: true
										}
									}
								},
								{
									name: "settings.company.documents",
									path: "/settings/company/:company/documents",
									component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/settings/company/edit/Documents"),
									meta: {
										auth: {
											admin: true
										}
									}
								},
								{
									name: "settings.company.access-control",
									path: "/settings/company/:company/access-control",
									component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/settings/company/edit/AccessControl"),
									meta: {
										auth: {
											admin: true
										}
									}
								},
								{
									name: "settings.company.customPage",
									path: "/settings/company/:company/page/:path",
									component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/settings/company/CustomPage"),
									meta: {
										auth: {
											admin: true,
											freeTeacher: false
										}
									}
								},
								{
									name: "settings.company.downloadCSV",
									path: "/settings/company/:company/download-csv",
									component: () => import(/* webpackChunkName: "settings" */ "@/views/pages/settings/company/DownloadCSV"),
									meta: {
										auth: {
											admin: true,
											freeTeacher: true
										}
									}
								}
							]
						},

						{
							name: "settings.login",
							path: "/settings/login",
							component: () => import(/* webpackChunkName: "login" */ "@/views/pages/settings/LoginSettings"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						// {
						// 	name: "settings.audit",
						// 	path: "/settings/audit",
						// 	component: () => import(/* webpackChunkName: "audit" */ "@/views/pages/settings/Audit"),
						// 	meta: {
						// 		auth: {
						// 			admin: true
						// 		}
						// 	}
						// },
						{
							name: "settings.credentials",
							path: "/settings/credentials",
							component: () => import(/* webpackChunkName: "credentials" */ "./../components/private/components/pages/settings/credentials/Credentials.vue"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						{
							name: "settings.credentials.staff",
							path: "/settings/credentials/staff",
							component: () =>
								import(/* webpackChunkName: "credentials" */ "./../components/private/components/pages/settings/credentials/StaffCredentials.vue"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						{
							name: "settings.credentials.students",
							path: "/settings/credentials/students",
							component: () =>
								import(/* webpackChunkName: "credentials" */ "./../components/private/components/pages/settings/credentials/StudentCredentials.vue"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						{
							name: "settings.credentials.invite-staff",
							path: "/settings/credentials/invite",
							component: () => import(/* webpackChunkName: "credentials" */ "./../components/private/components/pages/settings/credentials/InviteStaff.vue"),
							meta: {
								auth: {
									admin: true
								}
							}
						},
						{
							name: "settings.sso.invite-staff.sent",
							path: "/settings/credentials/invite/sent",
							component: () =>
								import(/* webpackChunkName: "credentials" */ "./../components/private/components/pages/settings/credentials/InviteStaffSent.vue"),
							meta: {
								auth: {
									admin: true
								}
							}
						}
					]
				},
				{
					name: "sso.logout",
					path: "/sso/logout",
					component: () => import(/* webpackChunkName: "logout" */ "./../components/public/pages/SSOLogout.vue"),
					meta: {
						auth: {
							teacher: true,
							admin: true,
							student: true
						}
					}
				}
			]
		},
		{
			name: "404",
			path: "*",
			component: Error404,
			meta: {
				auth: {
					admin: true
				}
			}
		}
	]
});

router.afterEach((to, from) => {
	window.scrollTo(0, 0);
});

const { requestSanitizer, responseSanitizer } = LogrocketFuzzySanitizer.setup([
	'first_name',
	'firstName',
	'last_name',
	'lastName',
	'display_name',
	'displayName',
	'email',
	'email_address',
	'emailAddress',
	'forename',
	'surname',
	'dob',
	'date_of_birth',
	'password',
	'value',
	'phone_number',
	'name',
]);

router.beforeEach(async (to, from, next) => {
	let redirectToDash = false;

	LogRocket.init("mtcrhe/edu-v1", {
		network: {
			requestSanitizer,
			responseSanitizer
		},
	});

	if(to && to.query && to.query.debug) {
		console.log('LogRocket recording debug:', to.query.debug);
		LogRocket.identify(to.query.debug);
	}

	// If trying to go to saml login then just let it, prevent loops
	if (to && to.name === "saml-login") {
		return next();
	}

	if (to && to.query && to.query.SAMLRequest && to.query.RelayState) {
		// Create the cookie to store that this is a saml login request
		cookie.createSAMLCookie(to.query.SAMLRequest, to.query.RelayState);
	}

	if (to.meta.public) {
		if ((to.meta.redirectIfLoggedIn === undefined || to.meta.redirectIfLoggedIn === true) && cookie.doesLoginCookieExist()) {
			// Allow to proceed to auth check
			redirectToDash = true;
		} else {
			return next();
		}
	}

	document.body.classList.remove("unauthenticated");
	document.body.classList.add("authenticated");

	window.privateApolloClient.mutate({
		mutation: clearBreadcrumbsMetaMutation
	});

	const {
		data: { User: user }
	} = await window.privateApolloClient
		.query({
			query: gql`
				{
					User {
						id
						wrn
						first_name
						last_name
						display_name
						is_organisation_admin
						originally_organisation_admin
						is_admin
						is_teacher
						is_free_teacher
						is_student
						is_free_student
						email
						portalV2JWT
						organisation_id
						organisation_uuid
						School {
							id
							demo
							name
							sso_enabled
							portal_version
							portal_version_upgrade_check
						}
						Classrooms {
							id
							name
						}
						Organisation {
							uuid
							name
							portal_version
							redirect_to_version_2
						}
					}
				}
			`
		})
		.catch(log => {
			if (log && log.networkError && log.networkError.statusCode === 401) {
				window.privateApolloClient.resetStore();
				cookie.deleteLoginCookie();

				window.Intercom("shutdown");
			}

			if (to.name == "install") {
				cookie.createIntendedRouteCookie(to.fullPath);
			}

			return router.push({ name: "login", query: to.query });
		});

	// Not logged in? Redirect to login screen
	if (!user) {
		if (to.name == "install") {
			cookie.createIntendedRouteCookie(to.fullPath);
		}

		return router.push({ name: "login", query: to.query });
	}

	try {
		window.Intercom("update", {
			name: user.display_name,
			first_name: user.first_name,
			last_name: user.last_name,
			email: user.email,
			user_id: user.id,
			is_admin: user.is_admin,
			environment: process.env.NODE_ENV,
			is_teacher: user.is_teacher,
			is_free_teacher: user.is_free_teacher,
			is_student: user.is_student,
			is_organisation_admin: user.is_organisation_admin,
			is_demo: user.School ? user.School.demo : false,
			company: user.Organisation
				? {
						id: user.Organisation.uuid,
						name: user.Organisation.name
				  }
				: {
						id: user.School.id,
						name: user.School.name,
						demo: user.School.demo,
						sso_enabled: user.School.sso_enabled
				  },
			sso_enabled: user.School.sso_enabled
		});
	} catch (e) {
		console.error("Failed to update intercom");
	}

	// If there is a saml cookie, we redirect to the saml login page to complete auth
	if (cookie.doesIntendedRouteCookieExist()) {
		const route = cookie.getIntendedRouteCookie();
		cookie.deleteIntendedRouteCookie();
		return router.push(route);
	}

	// If there is a saml cookie, we redirect to the saml login page to complete auth
	if (cookie.doesSAMLCookieExist()) {
		return router.push({ name: "saml-login", query: to.query });
	}

	// If it's an organisation we swap the dashboard for the org dashboard
	if (user.is_organisation_admin && to.name == "dashboard") {
		return router.push({ name: "organisation", query: to.query });
	}

	if (redirectToDash) {
		return router.push({ name: "dashboard", query: to.query });
	}

	const {
		meta: { auth, validation }
	} = to;

	LogRocket.identify(user.id);

	if (auth) {
		const authCheck = (() => {
			if (auth.organisation && user.is_organisation_admin) {
				return true;
			}

			if (auth.admin && user.is_admin) {
				return true;
			}

			if (auth.teacher && user.is_teacher) {
				return true;
			}

			if (auth.student && user.is_student) {
				return true;
			}

			if (auth.freeTeacher && user.is_free_teacher) {
				return true;
			}

			if (auth.freeStudent && user.is_free_student) {
				return true;
			}

			if (user.is_free_teacher || user.is_free_student) {
				if (!user.Classrooms[0]) {
					return { name: "register.teacher.createClassroom" };
				}

				return { name: "classroom.show", params: { class: user.Classrooms[0].id, noAccess: !["dashboard", "root"].includes(to.name) }, query: to.query };
			}

			return { name: "dashboard", params: { noAccess: true }, query: to.query };
		})();

		const redirectToSchoolPortalV2 = () => {
			try {
				let company = {}, domain;

				if(user.is_admin) {
					domain = `${process.env.PORTAL_V2_SCHOOL_URL}/login`;
				} else if(user.is_organisation_admin) {
					domain = `${process.env.PORTAL_V2_ENTERPRISE_URL}/login`;
				} else {
					domain = `${process.env.MY_LOGIN_URL}/login/edu`;
				}

				if (user.is_organisation_admin && cookie.doesAuthorizeCookieExist()) {
					({ company } = cookie.getAuthorizeCookie());
				}

				document.body.innerHTML += `
					<form id="school-portal-version-2-sso-login" action="${domain}" method="post">
						<input type="hidden" name="jwt" value="${user.portalV2JWT}">
						<input type="hidden" name="companySlug" value="${company.slug || ''}">
					</form>
				`;

				document.getElementById('school-portal-version-2-sso-login').submit();
			} catch (e) {
				console.log(e);
			}
		}

		const isSchoolPortalV2 = () => {
			if(user.is_admin || user.is_student || user.is_teacher) {
				return user.School.portal_version === 2 || user.School.portal_version_upgrade_check;
			} else if (user.is_organisation_admin) {
				return user.Organisation.portal_version === 2 || user.Organisation.redirect_to_version_2;
			}

			return false;
		}

		if(isSchoolPortalV2()) {
			redirectToSchoolPortalV2();
		}

		if (typeof authCheck === "object") {
			return router.push(authCheck);
		}
	}

	if (validation) {
		const res = validation(user);

		if (res === false) {
			return router.push({ name: "dashboard", params: { noAccess: true }, query: to.query });
		}

		if (typeof res === "object") {
			return router.push(res);
		}
	}

	return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js